import styled from 'styled-components';

const EventMapStyles = styled.div``;

export default EventMapStyles;
